import { 
  Modal as AntModal,
  Button as AntButton, 
} from 'antd';
import styled from 'styled-components';
import {  
  BonusModalAcceptBtnBg, 
  BonusModalRejectBtnBg 
} from '@assets';
import {  BURMESE_LANGUAGE_CODE_LK } from "@constants";

export const Modal = styled(AntModal)`
  padding: 0px !important;

  .ant-modal-title {
    text-align: center;
    color: ${(props) => props.theme.primaryColor};
  }
  .ant-modal-content {
    background-image: url(${(prop) => prop.bg}) !important;
		background-size: contain !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
    background-color: green;
    width: 315px;
    height: 378px;
    margin: 0 auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  .ant-modal-footer {
    text-align: center;
  }

  .ant-btn-default{
    color: #FFF !important;
    background-color: transparent !important;
  }

  .ant-btn-default:hover{
    color: #FFF !important;
    background-color: transparent !important;
  }

  @media screen and (max-width: 370px) {
    .ant-modal-content{
      width: 300px;
      height: 350px;
    }
  }

  @media screen and (max-width: 320px) {
    .ant-modal-content{
      width: 270px;
      height: 350px;
    }
  }
`

export const Title = styled.div`
  padding: ${(props) => props.lan === BURMESE_LANGUAGE_CODE_LK ? "14px 0 0 46px" : '19px 0 0 46px'} ;
  opacity: ${props => props.hide === 'true' ? 0 : 1};
  
  color: #FFF;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; /* 173.333% */

  @media screen and (max-width: 370px) {
    padding-top: 0px;
    font-size: 14px;
  }

  @media screen and (max-width: 370px) {
    padding-top: 4px;
    font-size: 13px;
  }
`

export const Container = styled.div`

  position: absolute;
  top: 100px;
  left: 0px;
  margin: 18px 0;
  width: 100%;
  height: 250px;

  @media screen and (max-width: 370px) {
    top: 105px;
    height: 210px;
  }
`

export const LabelContainer = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const MainText = styled.div`

  width: 90%;
  margin-top: ${(props) => props.lan === BURMESE_LANGUAGE_CODE_LK ? "10px" : '25px'};

  color: #FFF;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5; 
  white-space: pre-line;

  @media screen and (max-width: 370px) {
    font-size: 12px;
    margin-top: 5px;
  }

  @media screen and (max-width: 320px) {
    font-size: 11px;
  }
`

export const Bottom = styled.div`
  position: absolute;
  bottom: 0px;
  width: 90%;
  left: 5%;
  text-align: center;


  @media screen and (max-width: 370px) {
    bottom: 5px;
  }

`;


export const Description = styled.div`
  margin: 10px 0 0 0;

  color: #FF8080;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; /* 158.333% */

  @media screen and (max-width: 370px) {
    font-size: 8px;
  }
`

export const ButtonWrapper = styled.div`

  margin: 10px 0 0 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 15px;
  padding: 0 4px;
  
  svg{
    cursor: pointer;
  }

  @media screen and (max-width: 370px) {
    gap: 10px;
    padding: 0;
  }

`

const BasicButton = styled(AntButton)`
  font-size: 12px;
  width: 100%;
  height: 46px;

  @media screen and (max-width: 420px) {
    font-size: 10px;
    height: 40px;
  }

`

export const AcceptButtonWrapper = styled.div`
  width: 50%;
`

export const AcceptButton = styled(BasicButton)`
  background-image: url(${BonusModalAcceptBtnBg}) !important;
  background-color: transparent !important;
  background-size: cover;
  background-repeat: no-repeat;

  line-height: normal;

  :hover{
    background-color: transparent !important;
    color: #FFF !important;
  }
`

export const RejectButtonWrapper = styled.div`
  width: 50%;
`

export const RejectButton = styled(BasicButton)`
  background-image: url(${BonusModalRejectBtnBg}) !important;
  background-color: transparent !important;
  background-size: cover;
  background-repeat: no-repeat;


  :hover{
    background-image: url(${BonusModalRejectBtnBg}) !important;
    background-color: transparent !important;
    color: #FFF !important;
  }
`